import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import keys from 'common/react-query/data-keys';
import { handleError } from 'common/utils/util.errors';
import { LinearProgress } from '@mui/material';
import { ProjectAnalysisWrapper } from './ProjectAnalysisWrapper';
import { getDivisions } from '../glossary/glossary.api';
import { getProjectAnalysis } from '../project/project.api';
import { FileUploadErrorDTO } from '../project/project.type';

interface ProjectAnalysisProps {
  projectErrors: FileUploadErrorDTO[];
}

export const ProjectAnalysis: React.FC<ProjectAnalysisProps> = ({ projectErrors }) => {
  const navigate = useNavigate();
  const { projectId } = useParams<{ projectId: string }>();
  const [isCreating, setIsCreating] = useState(false);
  const {
    data: projectAnalysis,
    isLoading: isLoadingProjectAnalysis,
    isError: isErrorProjectAnalysis,
    error: errorProjectAnalysis,
    refetch: refetchProjectAnalysis,
  } = useQuery([keys.projectAnalysis, projectId], () => getProjectAnalysis(projectId ?? ''), {
    enabled: !!projectId,
  });

  const {
    data: divisions,
    isLoading: isLoadingDivisions,
    isError: isErrorDivisions,
    error: errorDivisions,
  } = useQuery(keys.divisions, getDivisions);

  if (!projectId) {
    navigate('./NotFound');
  }
  if (isErrorProjectAnalysis || isErrorDivisions) {
    handleError(errorProjectAnalysis || errorDivisions);
    return null;
  }
  if (isLoadingProjectAnalysis || isLoadingDivisions) {
    return <LinearProgress />;
  }

  if (!projectAnalysis || !divisions) {
    return null;
  }

  return (
    <>
      <ProjectAnalysisWrapper initialProjectAnalysis={projectAnalysis} divisions={divisions} projectErrors={projectErrors} />
    </>
  );
};

export default ProjectAnalysis;
